/**
 * POST /api/v1/accounts/:accountId/contacts/:contactId/lead_quality
 */
/* global axios */
export async function generateLeadQuality(accountId, contactId) {
  const url = `/api/v1/accounts/${accountId}/contacts/${contactId}/lead_quality`;
  const response = await axios.post(url);
  return response.data;
}

/**
 * PATCH /api/v1/accounts/:accountId/contacts/:contactId/lead_quality
 * @param {{ lead_quality_score: number, reasons?: string }} payload
 */
export async function updateLeadQualityManually(
  accountId,
  contactId,
  { lead_quality_score, reasons = '' }
) {
  const url = `/api/v1/accounts/${accountId}/contacts/${contactId}/lead_quality`;
  const response = await axios.patch(url, {
    lead_quality_score,
    reasons,
  });
  return response.data;
}

/**
 * DELETE /api/v1/accounts/:accountId/contacts/:contactId/lead_quality
 */
export async function clearLeadQuality(accountId, contactId) {
  const url = `/api/v1/accounts/${accountId}/contacts/${contactId}/lead_quality`;
  const response = await axios.delete(url);
  return response.data;
}
